import React, { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import magnifierImage from '../../assets/magnifier_illustration.png'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)({
  width: '80px',
  height: '80px',
})

/**
 * Illustration to show when a search has no results
 */
export const MagnifierIllustration: FunctionComponent = () => (
  <ImageContainer testID={tID('MagnifierIllustration')} source={magnifierImage as ImageSourcePropType} />
)
